import {useState} from 'react'
import {frontends, DfnsDepositCryptoAssets} from '@bdswiss/common-enums'
import type {MutationFunction, MutationResult} from 'react-apollo'
import {Trans} from 'react-i18next'
import {MenuItem, Select, FormControl, InputLabel} from '@material-ui/core'
import {useHistory} from 'react-router-dom'

import messages from '../../../../assets/messages'
import {getPlatform} from '../../../../common/utils'
import {withCreateDeposit, PaymentActionButton} from './helpers'

interface DfnsProviderProps {
  createDepositRequest: MutationFunction<{newDeposit: {payment: {url: string}}}>
  createDepositResult: MutationResult
  providerProperties: {provider: string; paymentKey: string}
  account: {id: number}
  amount: number
  onError: (e: unknown) => void
  bonusAmount: boolean
  bonusTerms: boolean
  disablePayment: boolean
}

const cryptoAssets = Object.values(DfnsDepositCryptoAssets)
type CryptoAsset = keyof typeof DfnsDepositCryptoAssets

function DfnsProvider({
  createDepositRequest,
  createDepositResult,
  disablePayment,
  providerProperties: {paymentKey, provider},
  bonusAmount,
  bonusTerms,
  amount,
  account,
  onError,
}: DfnsProviderProps) {
  const history = useHistory()
  const [digitalAsset, setDigitalAsset] = useState<CryptoAsset | null>(null)
  const handleSubmit = async () => {
    const variables = {
      accountId: account.id,
      amount,
      vendor: provider,
      frontend: frontends.web2.value,
      args: JSON.stringify({
        platform: getPlatform(),
        paymentKey,
        digitalAsset,
        bonusAmount,
        bonusTerms,
      }),
    }
    createDepositRequest({variables})
      .then(({data}) => {
        if (data?.newDeposit.payment.url) history.push(data.newDeposit.payment.url)
      })
      .catch((e) => onError(e))
  }

  return (
    <FormControl>
      <InputLabel id="digital-asset-select">
        <Trans {...messages.cryptoAsset} />
      </InputLabel>
      <Select
        value={digitalAsset ?? ''}
        labelId="digital-asset-select"
        label="Crypto asset"
        onChange={(e) => {
          setDigitalAsset(e.target.value as CryptoAsset)
        }}
      >
        {cryptoAssets.map(({value, label}) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <PaymentActionButton
        loading={createDepositResult.loading}
        onClick={handleSubmit}
        disable={disablePayment || digitalAsset === null}
      />
    </FormControl>
  )
}

export default withCreateDeposit(DfnsProvider)
